const RevenueSpendByAccountOfferSpendDetailsTableLangKey = [
	'column_id',
	'column_date',
	'column_amount',
	'column_percent',
	'column_offer',
	'column_scope',
	'column_notes',

] as const

type IRevenueSpendByAccountOfferSpendDetailsTableLangKey = typeof RevenueSpendByAccountOfferSpendDetailsTableLangKey[number]

export type IRevenueSpendByAccountOfferSpendDetailsTableLang = {
	revenue_spend_by_account_offer_spend_details_table: Record<IRevenueSpendByAccountOfferSpendDetailsTableLangKey, string>
}

const langEntries = RevenueSpendByAccountOfferSpendDetailsTableLangKey.map(
	(key: IRevenueSpendByAccountOfferSpendDetailsTableLangKey) => [key, `revenue_spend_by_account_offer_spend_details_table.${key}`]
)

const langObj: Record<IRevenueSpendByAccountOfferSpendDetailsTableLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_SPEND_BY_ACCOUNT_OFFER_SPEND_DETAILS_TABLE_LANG_KEY: IRevenueSpendByAccountOfferSpendDetailsTableLang = {
	revenue_spend_by_account_offer_spend_details_table: langObj
}
